import isArray from 'lodash/isArray';
import mergeWith from 'lodash/mergeWith';
import Raven from 'raven-js';
import SentryRelease from 'sentry-release';

const ravenOptions = {
    whitelistUrls: [
        /d2yt77z1f5bzb8\.cloudfront\.net\/static\/main\/js/,
        /spothero\.com/
    ],
    ignoreErrors: [
        // Random plugins/extensions
        'top.GLOBALS',
        // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error. html
        'originalCreateNotification',
        'canvas.contentDocument',
        'MyApp_RemoveAllHighlights',
        'http://tt.epicplay.com',
        'Can\'t find variable: ZiteReader',
        'jigsaw is not defined',
        'ComboSearch is not defined',
        'http://loading.retry.widdit.com/',
        'atomicFindClose',
        // This is a result of changing scrollTop property on the body in ie11, warning only
        'Assignment to read-only properties is not allowed in strict mode',
        // Facebook borked
        'fb_xd_fragment',
        // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to reduce this. (thanks @acdha)
        // See http://stackoverflow.com/questions/4113268/how-to-stop-javascript-injection-from-vodafone-proxy
        'bmi_SafeAddOnload',
        'EBCallBackMessageReceived',
        // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
        'conduitPage',
        'Can\'t find variable: _gat',
        /_gat is not defined/i,
        'ReferenceError: Can\'t find variable: _gat',
        '\'_gat\' is undefined',
        'Uncaught TypeError: Property \'$\' of object',
        'TypeError: Property \'$\' of object',
        '\'clickdesk_log\' is undefined',
        'TypeError: Unable to delete property.',
        'd is null',
        'Branch SDK initialization failed, so further methods cannot be called',
        /__gCrWeb\.autofill\.extractForms/i, // https://groups.google.com/a/chromium.org/forum/#!topic/chromium-discuss/7VU0_VvC7mE
        'InvalidPointerId',
        'Request blocked by client, probably adblock',
        /NPObject/i,
        'Can\'t find variable: google_tag_manager',
        'document.getElementsByClassName.ToString' // https://github.com/SamsungInternet/support/issues/56
    ],
    ignoreUrls: [
        // Facebook flakiness
        /graph\.facebook\.com/i,
        // Facebook blocked
        /connect\.facebook\.net\/en_US\/all\.js/i,
        // Woopra flakiness
        /eatdifferent\.com\.woopra-ns\.com/i,
        /static\.woopra\.com\/js\/woopra\.js/i,
        // Chrome extensions
        /extensions\//i,
        /^chrome:\/\//i,
        // Other plugins
        /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
        /webappstoolbarba\.texthelp\.com\//i,
        /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
        /my\.clickdesk\.com\/clickdesk-ui\/browser\//i,
        /bam\.nr-data\.net/i,
        /maps\.google\.com/i,
        /maps(-api-v3)?\/api\/js/i,
        /branch/i,
        /typeform/i,
        /d2yt77z1f5bzb8\.cloudfront\.net\/static\/vendor_legacy/i,
        /d2yt77z1f5bzb8\.cloudfront\.net\/static\/admin/i,
        /answerdash/i
    ],
    includePaths: [
        /https?:\/\/d2yt77z1f5bzb8\.cloudfront\.net/i
    ],
    release: SentryRelease.RELEASE
};

export default {
    init({apiKey, additionalRavenOptions, isAuthenticated, email, id}) {
        // merge arrays nested inside of the passed options with those in the default config options
        const options = mergeWith({}, ravenOptions, additionalRavenOptions, (a, b) => {
            return isArray(a) ? a.concat(b) : undefined;
        });

        Raven.config(apiKey, options).install();

        if (isAuthenticated) {
            Raven.setUser({email, id});
        }
    },

    addData(data) {
        Raven.setExtraContext(data);
    },

    sendMessage({message, level = 'warn'}) {
        Raven.captureMessage(message, {
            level
        });
    }
};



// WEBPACK FOOTER //
// ./frontend/src/js/debug/sentry.js